// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 본문 섹션 */
.registration-section {
    padding: 60px;
}

.section-container {
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 60px;
    max-width: 1100px;
    margin: 0 auto;
}

h2 {
    font-size: 36px;
    font-weight: 900;
    margin-bottom: 20px;
}

.intro {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.8;
}

.top-right {
    grid-column: 2;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
}

.top-row {
    display: flex;
    gap: 30px;
    justify-content: flex-start;
}

.top-row .cert-item {
    width: 100%;
    height: 340px;
}

/* 전체 폭으로 펼쳐지는 그리드: 컨테이너 내에서 가로 전체(span) */
.cert-grid {
    grid-column: 1 / -1;
    /* <-- 중요: 부모 그리드 전체 폭 차지 */
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    margin-top: 10px;
}

/* 인증서 박스 공통 */
.cert-item {
    border: 1px solid #efefef;
    background: #fff;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
}

/* 이미지 비율 유지 */
.cert-item img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
}

/* 반응형 */
@media (max-width: 1000px) {
    .registration-section .container {
        grid-template-columns: 260px 1fr;
        gap: 24px;
    }

    .top-row .cert-item {
        width: 200px;
        height: 300px;
    }

    .cert-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

.cert-title {
    width: 100%;
    margin-top: 14px;
    font-size: 15px;
    font-weight: 700;
    color: #111;
    text-align: center;
    word-break: keep-all;
    /* 단어 끊김 방지 */
    white-space: normal;
    /* 줄바꿈 허용 */
}

@media (max-width: 760px) {
    .registration-section .container {
        grid-template-columns: 1fr;
    }

    .top-right {
        grid-column: 1 / -1;
    }

    .top-row {
        justify-content: center;
    }

    .top-row .cert-item {
        width: 160px;
        height: 240px;
    }

    .cert-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 420px) {
    .cert-grid {
        grid-template-columns: 1fr;
    }

    .top-row .cert-item {
        width: 140px;
        height: 200px;
    }
}`, "",{"version":3,"sources":["webpack://./static/css/registration.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA,0CAA0C;AAC1C;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA,cAAc;AACd;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,QAAQ;AACR;IACI;QACI,gCAAgC;QAChC,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ","sourcesContent":["/* 본문 섹션 */\n.registration-section {\n    padding: 60px;\n}\n\n.section-container {\n    display: grid;\n    grid-template-columns: 1fr 3fr;\n    gap: 60px;\n    max-width: 1100px;\n    margin: 0 auto;\n}\n\nh2 {\n    font-size: 36px;\n    font-weight: 900;\n    margin-bottom: 20px;\n}\n\n.intro {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 1.8;\n}\n\n.top-right {\n    grid-column: 2;\n    display: flex;\n    justify-content: flex-end;\n    gap: 20px;\n}\n\n.top-row {\n    display: flex;\n    gap: 30px;\n    justify-content: flex-start;\n}\n\n.top-row .cert-item {\n    width: 100%;\n    height: 340px;\n}\n\n/* 전체 폭으로 펼쳐지는 그리드: 컨테이너 내에서 가로 전체(span) */\n.cert-grid {\n    grid-column: 1 / -1;\n    /* <-- 중요: 부모 그리드 전체 폭 차지 */\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 24px;\n    margin-top: 10px;\n}\n\n/* 인증서 박스 공통 */\n.cert-item {\n    border: 1px solid #efefef;\n    background: #fff;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);\n}\n\n/* 이미지 비율 유지 */\n.cert-item img {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n    display: block;\n}\n\n/* 반응형 */\n@media (max-width: 1000px) {\n    .registration-section .container {\n        grid-template-columns: 260px 1fr;\n        gap: 24px;\n    }\n\n    .top-row .cert-item {\n        width: 200px;\n        height: 300px;\n    }\n\n    .cert-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n.cert-title {\n    width: 100%;\n    margin-top: 14px;\n    font-size: 15px;\n    font-weight: 700;\n    color: #111;\n    text-align: center;\n    word-break: keep-all;\n    /* 단어 끊김 방지 */\n    white-space: normal;\n    /* 줄바꿈 허용 */\n}\n\n@media (max-width: 760px) {\n    .registration-section .container {\n        grid-template-columns: 1fr;\n    }\n\n    .top-right {\n        grid-column: 1 / -1;\n    }\n\n    .top-row {\n        justify-content: center;\n    }\n\n    .top-row .cert-item {\n        width: 160px;\n        height: 240px;\n    }\n\n    .cert-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 420px) {\n    .cert-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .top-row .cert-item {\n        width: 140px;\n        height: 200px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
